// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"30389591","513":"b5d8bd94","787":"49c25511"}[chunkId] + ".chunk.js";
};